// Singleton used to store data for use with Telemetry.
// This class should never be used for any business logic
export class TelemetryData {
    constructor() {
        this._pcsBuildVersion = "NA";
        this._widgetsBuildVersion = "NA";
        this._view = 1;
        this._isWindowVisible = false;
    }
    static set view(fullView) {
        let fullViewBoolean = fullView;
        TelemetryData.instance._view = fullViewBoolean ? 2 /* FullView */ : 1 /* HalfView */;
    }
    static get view() {
        return TelemetryData.instance._view;
    }
    static set pcsBuildVersion(pcsBuildVersion) {
        let pcsBuildVersionString = pcsBuildVersion;
        if (pcsBuildVersionString) {
            TelemetryData.instance._pcsBuildVersion = pcsBuildVersion;
        }
    }
    static get pcsBuildVersion() {
        return TelemetryData.instance._pcsBuildVersion;
    }
    static set widgetsBuildVersion(widgetsBuildVersion) {
        let widgetsBuildVersionString = widgetsBuildVersion;
        if (widgetsBuildVersionString) {
            TelemetryData.instance._widgetsBuildVersion = widgetsBuildVersion;
        }
    }
    static get widgetsBuildVersion() {
        return TelemetryData.instance._widgetsBuildVersion;
    }
    static set isWindowVisible(isWindowVisible) {
        TelemetryData.instance._isWindowVisible = isWindowVisible;
    }
    static get isWindowVisible() {
        return TelemetryData.instance._isWindowVisible;
    }
    static get instance() {
        if (TelemetryData._instance === undefined) {
            TelemetryData._instance = new TelemetryData();
        }
        return TelemetryData._instance;
    }
}
